import GameSidebar from "./GameSidebar";
import GamePreview from "./GamePreview";
import GameRightSidebar from "./GameRightSidebar";
import "./Css/GamePageLayout.css"; // Adjust the path as necessary
import AdvertisementLeft from "./AdvertisementLeft";
import AdvertisementRight from "./AdvertisementRight";
import Advertise from "./Advertise";
import { useState } from "react";

const GamePageLayout = () => {
  const [newClass, setNewClass] = useState("");
  return (
    <>
      <div
        className={`layout-container ${newClass}`}
        style={{ height: "82vh !important" }}
      >
        <AdvertisementLeft />
        <GameSidebar position="left" />
        <GamePreview setNewClass={setNewClass} />
        {/* <GameRightSidebar position="right" /> */}
        <AdvertisementRight />
      </div>

      <div className="game_advertise">
        <Advertise slot="3949892176" width="97%" />
      </div>
    </>
  );
};

export default GamePageLayout;
